import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/img/logo.svg'


const _hoisted_1 = { class: "nav-menu" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}

import { computed, ComputedRef } from 'vue'
import { useStore } from '@/store'
import { useRouter, useRoute } from 'vue-router'
import { pathMapToMenuWithParent } from '@/utils/map-menus'
import { RouterVo } from '@/api/vo/user-vo'


export default /*@__PURE__*/_defineComponent({
  __name: 'admin-menu',
  props: {
  collapse: Boolean
},
  setup(__props) {

const props = __props

// store
const store = useStore()
const userMenus: ComputedRef<RouterVo[]> = computed(() => store.state.login.userMenus)

// router
const router = useRouter()
const route = useRoute()

// 根据当前路由（含标签切换）动态计算选中的菜单项和展开的父级目录
const activeMenuResult = computed(() => {
  const path = route.path
  return pathMapToMenuWithParent(userMenus.value, path)
})

const defaultValue = computed(() => {
  const { menu } = activeMenuResult.value
  return menu?.id ? String(menu.id) : ''
})

// 仅展开当前选中菜单所在的父级目录，配合 unique-opened 实现手风琴效果
const defaultOpeneds = computed(() => {
  const { parent } = activeMenuResult.value
  return parent?.id ? [String(parent.id)] : []
})

// 路由变化时更新 key，强制菜单重新挂载以正确应用 default-openeds（解决 Element Plus 动态更新失效）
const menuKey = computed(() => route.path)

// event handle
const handleMenuItemClick = (item: RouterVo) => {
  router.push({
    path: item.path ?? '/not-found'
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        class: "img",
        src: _imports_0,
        alt: "logo"
      }, null, -1)),
      (!__props.collapse)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Vue3+TS"))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_component_el_menu, {
      key: menuKey.value,
      "default-active": defaultValue.value,
      "default-openeds": defaultOpeneds.value,
      "unique-opened": "",
      class: "el-menu-vertical",
      collapse: __props.collapse,
      "background-color": "#0c2135",
      "text-color": "#b7bdc3",
      "active-text-color": "#0a60bd"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userMenus.value, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.id
          }, [
            (item.menuType === 'M')
              ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                  key: 0,
                  index: item.id + ''
                }, {
                  title: _withCtx(() => [
                    (item.meta?.icon)
                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon)))
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(item.menuName), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subitem) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: subitem.id
                      }, [
                        (subitem.menuType === 'M')
                          ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                              key: 0,
                              index: subitem.id + ''
                            }, {
                              title: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(subitem.menuName), 1)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subitem.children, (subsubitem) => {
                                  return (_openBlock(), _createBlock(_component_el_menu_item, {
                                    key: subsubitem.id,
                                    index: subsubitem.id + '',
                                    onClick: ($event: any) => (handleMenuItemClick(subsubitem))
                                  }, {
                                    default: _withCtx(() => [
                                      (subsubitem.meta?.icon)
                                        ? (_openBlock(), _createElementBlock("i", {
                                            key: 0,
                                            class: _normalizeClass(subsubitem.meta?.icon)
                                          }, null, 2))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", null, _toDisplayString(subsubitem.menuName), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["index", "onClick"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["index"]))
                          : (subitem.menuType === 'C')
                            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                key: 1,
                                index: subitem.id + '',
                                onClick: ($event: any) => (handleMenuItemClick(subitem))
                              }, {
                                default: _withCtx(() => [
                                  (subitem.meta?.icon)
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 0,
                                        class: _normalizeClass(subitem.meta?.icon)
                                      }, null, 2))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", null, _toDisplayString(subitem.menuName), 1)
                                ]),
                                _: 2
                              }, 1032, ["index", "onClick"]))
                            : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["index"]))
              : (item.menuType === 'C')
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 1,
                    index: item.id + ''
                  }, {
                    default: _withCtx(() => [
                      (item.meta?.icon)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: _normalizeClass(item.meta?.icon)
                          }, null, 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(item.menuName), 1)
                    ]),
                    _: 2
                  }, 1032, ["index"]))
                : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["default-active", "default-openeds", "collapse"]))
  ]))
}
}

})